import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProjectCategory } from 'src/app/models/project-category.model';
import { ProjectCategoryService} from 'src/app/services/project-category.service'


@Component({
  selector: 'app-project-category-detail',
  templateUrl: './project-category-detail.component.html',
  styleUrls: ['./project-category-detail.component.css']
})
export class ProjectCategoryDetailComponent {
  category: ProjectCategory;
  showSpinner: boolean = true;

  constructor(
              private route: ActivatedRoute,
              private router: Router,
              private projectCategoryService: ProjectCategoryService,
              ) {}

  ngOnInit(): void {
    const id = this.route.snapshot.params['id']; 
    window.scrollTo(0, 0);
    this.projectCategoryService.getProjectCategory(id).subscribe(
      (response: ProjectCategory) => {
        console.log(response)
        this.category = response;
        this.showSpinner = false; 
      }
    );
  }

  deleteCourse(category: ProjectCategory) {
    this.projectCategoryService.projectCategories = this.projectCategoryService.projectCategories.filter(x => x.id !== category.id);
    this.projectCategoryService.emitProjectCategorySubject();
    this.router.navigate(['/project-category/list']);
  }
}
